import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {AiSparkleNewIcon} from 'shells/icon/svg/ai-sparkle-new-icon';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {Body} from 'shells/typography/body';

export function SuggestedReplyLabel() {
    return (
        <StackLegacy spacing={4} isHorizontal={true}>
            {/* @ts-expect-error */}
            <AiSparkleNewIcon color={colors.aiBlue} size={13} />
            <Body size='small' color='navy-dk' isBold={true}>
                Start a reply with AI
            </Body>
        </StackLegacy>
    );
}
